import { Van } from "./van";

export class Profile {
    adId: string = "";
    email: string = "";
    firstName: string = "";
    lastName: string = "";
    userRoles: Array<string> = [];
    vanList: Array<Van> = [];
  }